/**
 * Tiny Slider
 *
 * The rotator is a special kind of complicated, so all of that functionality is
 * in a separate partial.
 */

'use strict';

;( ( tns ) => {

	const sliders = document.querySelectorAll( '[data-slider]' );
	if ( 0 === sliders.length ) return;

	sliders.forEach( slider => {

		if ( 'rotator' === slider.dataset.slider ) return; // Handled in a separate partial.

		const options = {
			center   : true,
			container: slider,
			items    : 1,
			nav      : false,
			speed    : 750,
		};

		if ( matchMedia( '( prefers-reduced-motion: reduce )' ).matches ) {
			options.mode = 'gallery';
		}

		switch ( slider.dataset.slider ) {

		case 'portfolio-mobile':
			options.autoplay             = true;
			options.autoplayButtonOutput = false;
			options.autoplayTimeout      = 8000;
			options.gutter               = 20;
			options.mouseDrag            = true;
			break;

		case 'portfolio-desktop':
			options.axis    = 'vertical';
			options.gutter  = 20;
			options.items   = 3;
			options.loop    = false;
			options.slideBy = 'page';

			// Count the number of slides, and disable the arrow controls if <= 3.
			const slides = slider.querySelectorAll( '.tns-item' );
			if ( 3 >= slides.length ) {
				options.controls = false;
			}

			break;

		case 'site-hero':
			options.autoplay             = true;
			options.autoplayButtonOutput = false;
			options.autoplayTimeout      = 8000;
			break;

		case 'quotes':
			options.autoplay             = true;
			options.autoplayButtonOutput = false;
			options.autoplayTimeout      = 8000;
			break;

		case 'image-slideshow':
			options.gutter = 116;
			options.loop   = false;
		}

		tns( options );
	});

})( tns );
